import { get, post } from '@/apis/http';
import { apiPath } from '@/config';
import { cmsApis } from '@/config/cmsApi';


// 转发活动页接口  /uc/activity
export function getActicityParam(name, data = {}) {
    const path = cmsApis[name]
    return post(apiPath + '/uc/activity?path=' + path, data)
}
// 赔付活动 
export function getCompensate(name, data = {}) {
    const path = cmsApis[name]
    return post(apiPath + '/uc/paylosses?path=' + path, data)
}
export function postCmsSystemRelay(name, data = {}) {
    const path = cmsApis[name];
    return post(apiPath + '/common/pmCmsSystemRelay?path=' + path, data)
}

// 转发CMS详情接口
export function pmCmsSystemRelayUrlParam(name, data = {}) {
    const path = cmsApis[name];
    return post(apiPath + '/common/pmCmsSystemRelayUrlParam?path=' + path, data)
}
